import { API_URL } from '../../config/constants';
import { toast } from 'react-toastify';

export const uploadExcellDataSet = data => {
    let municipalityData = [];
    let total = 0;
    for (let i = 0; i < data.length; i++) {
        total += parseInt(data[i].personas, 10);
    }
    municipalityData = [...data];
    municipalityData.push({ municipality_name: "Total", personas: total });
    let excellData = {
        columns: [{
            label: "Localidade",
            value: "municipality_name"
        }, {
            label: "Visitantes",
            value: "personas"
        }],
        data: municipalityData ? municipalityData : [],
        key: "municipality_data"
    };
    return excellData;
}


export const loadData = async (sessionData, filter) => {
    try {
        let responseMunicipality = await getPeopleByMunicipalities(sessionData.userName, sessionData.passwd, filter);
        let excellData = uploadExcellDataSet(responseMunicipality.result.data);
        return { data: responseMunicipality.result.data, excellData: excellData, total: responseMunicipality.result.total };
    } catch (err) {
        console.error(err);
        toast("Produciuse un erro ao obter os datos. Intenteo de novo máis tarde", { className: "toast-error", autoClose: 3500 });
    }
}

export const getPeopleByMunicipalities = async (userName, passwd, filter) => {
    try {
        const request = new Request(API_URL + "/v2/getPeopleByMunicipalities", {
            method: 'POST',
            body: JSON.stringify({
                username: userName,
                password: passwd,
                filter: filter
            }),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        });
        const response = await fetch(request);
        if (response.status !== 200 && response.code !== 200) throw response;
        const json = await response.json();
        return json;
    } catch (err) {
        if (!err.code && !err.status) err.status = 500;
        throw err;
    }
}



// WEBPACK FOOTER //
// ./src/controllers/results/peopleByMunicipalities.js